import React from 'react';
import styled from 'styled-components';
import { Autocomplete, TextField } from '@mui/material';

const Wrapper = styled.div<{ disabled?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 20px;
  margin: 5px 0;
   opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

// const Icon = styled.img`
//   width: 20px;
//   height: auto;
//   margin: 0 10px 0 2px;
// `;

const StyledTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#c5c5c5',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#c5c5c5',
  },
  '& .MuiInputBase-input': {
    fontFamily: 'Figtree',
    fontWeight: 300,
    fontSize: 16,
    color: '#3d3d3d',
    height: 35,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: 0,
      border: 'none',
      borderBottom: '2px solid #FFF200',
      // borderColor: '#c5c5c5',
      borderColor: '#FFF200',
    },
    '&:hover fieldset': {
      // borderColor: '#c5c5c5',
      borderColor: '#95D0DD',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#95d0dd',
      outline: 'none',
      borderWidth: 2,
    },
  },
});

export type Option = {
  value: string;
  label: string;
}

export interface AutoCompleteProps {
  options: Option[];
  value: Option | undefined;
  handleChange: (event: React.SyntheticEvent<Element, Event>, value: Option | null) => void;
  onBlur?: () => void;
  placeholder: string;
  icon?: string;
  disableClearable?: boolean;
  disabled?: boolean;
  error?: string;
}

const InputSelect = ({ options, handleChange, placeholder, icon, disableClearable = false, disabled = false, error }: AutoCompleteProps) => (
  <Wrapper disabled={disabled}>
    <Autocomplete
      disablePortal
      options={options}
      sx={{ width: '100%' }}
      disableClearable={disableClearable}
      onChange={handleChange}
      renderInput={(params) => (
        <StyledTextField {...params} placeholder={placeholder} disabled={disabled} />
      )}
    />
  </Wrapper>
);

export default InputSelect;
